import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../misc/guards/authenticated.guard';
import { PermissionsPageComponent } from './permissions.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: PermissionsPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class PermissionsPageRoutingModule {}
